import React from 'react';
import ReactECharts from 'echarts-for-react';

const GrowthChart = ({ data }) => {
  const option = {
    tooltip: {
      trigger: 'axis',
      backgroundColor: '#1e293b',
      borderWidth: 0,
      padding: [12, 16],
      textStyle: { color: '#fff', fontSize: 13, fontFamily: 'Inter' },
      formatter: (params) => {
        const val = params[0].value;
        const year = params[0].name;
        return `
          <div style="color: #94a3b8; font-size: 11px; margin-bottom: 4px; text-transform: uppercase; letter-spacing: 0.05em;">Year ${year} projection</div>
          <div style="font-weight: 700; font-size: 16px;">RM ${val.toLocaleString()}</div>
        `;
      },
    },
    grid: {
      left: '2%',
      right: '2%',
      bottom: '0%',
      top: '10%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: data.map(item => item.year),
      axisLine: { lineStyle: { color: '#f1f5f9' } },
      axisTick: { show: false },
      axisLabel: { 
        color: '#94a3b8',
        fontSize: 11,
        margin: 15
      }
    },
    yAxis: {
      type: 'value',
      splitLine: { lineStyle: { color: '#f8fafc', type: 'dashed' } },
      axisLabel: {
        color: '#94a3b8',
        fontSize: 11,
        formatter: (value) => `RM ${value >= 1000000 ? (value / 1000000).toFixed(1) + 'M' : (value / 1000) + 'k'}`
      }
    },
    series: [
      {
        name: 'Total Savings',
        type: 'line',
        smooth: 0.4,
        data: data.map(item => item.total),
        symbol: 'circle',
        symbolSize: 0,
        showSymbol: false,
        emphasis: {
          scale: true,
          itemStyle: {
            color: '#2563eb',
            borderWidth: 3,
            borderColor: '#fff'
          }
        },
        lineStyle: {
          width: 4,
          color: '#2563eb',
          shadowColor: 'rgba(37, 99, 235, 0.2)',
          shadowBlur: 15,
          shadowOffsetY: 8
        },
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: 'rgba(37, 99, 235, 0.15)' },
              { offset: 1, color: 'rgba(37, 99, 235, 0)' }
            ]
          }
        }
      }
    ]
  };

  return (
    <div className="w-full h-[350px]">
      <ReactECharts 
        option={option} 
        style={{ height: '100%', width: '100%' }}
        opts={{ renderer: 'svg' }}
      />
    </div>
  );
};

export default GrowthChart;